class TimesheetsController implements ng.IComponentController {
    constructor() {
        'ngInject';
    }
}

export const timesheetsComponent : ng.IComponentOptions = {
    controller : TimesheetsController,
    template :require('./timesheets.html')
}


// WEBPACK FOOTER //
// ./src/app/modules/timesheets/timesheets.component.ts